/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: _04YMe6l7UMq

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicLoadingPlaceholder.module.css"; // plasmic-import: _04YMe6l7UMq/css

createPlasmicElementProxy;

export type PlasmicLoadingPlaceholder__VariantMembers = {};
export type PlasmicLoadingPlaceholder__VariantsArgs = {};
type VariantPropType = keyof PlasmicLoadingPlaceholder__VariantsArgs;
export const PlasmicLoadingPlaceholder__VariantProps =
  new Array<VariantPropType>();

export type PlasmicLoadingPlaceholder__ArgsType = {};
type ArgPropType = keyof PlasmicLoadingPlaceholder__ArgsType;
export const PlasmicLoadingPlaceholder__ArgProps = new Array<ArgPropType>();

export type PlasmicLoadingPlaceholder__OverridesType = {
  placeholder?: Flex__<"div">;
};

export interface DefaultLoadingPlaceholderProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicLoadingPlaceholder__RenderFunc(props: {
  variants: PlasmicLoadingPlaceholder__VariantsArgs;
  args: PlasmicLoadingPlaceholder__ArgsType;
  overrides: PlasmicLoadingPlaceholder__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"placeholder"}
      data-plasmic-override={overrides.placeholder}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.placeholder,
        "myevals-react-frontend__placeholder"
      )}
    />
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  placeholder: ["placeholder"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  placeholder: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLoadingPlaceholder__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLoadingPlaceholder__VariantsArgs;
    args?: PlasmicLoadingPlaceholder__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicLoadingPlaceholder__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicLoadingPlaceholder__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLoadingPlaceholder__ArgProps,
          internalVariantPropNames: PlasmicLoadingPlaceholder__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLoadingPlaceholder__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "placeholder") {
    func.displayName = "PlasmicLoadingPlaceholder";
  } else {
    func.displayName = `PlasmicLoadingPlaceholder.${nodeName}`;
  }
  return func;
}

export const PlasmicLoadingPlaceholder = Object.assign(
  // Top-level PlasmicLoadingPlaceholder renders the root element
  makeNodeComponent("placeholder"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicLoadingPlaceholder
    internalVariantProps: PlasmicLoadingPlaceholder__VariantProps,
    internalArgProps: PlasmicLoadingPlaceholder__ArgProps
  }
);

export default PlasmicLoadingPlaceholder;
/* prettier-ignore-end */
